import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Instagram from '../../homepage/components/instagram/Instagram';
import JoinNow from '../../homepage/components/join_now/JoinNow';

document.addEventListener('DOMContentLoaded', () => {
  createRoot(
    document.getElementById('join-now'),
  ).render(
    <Provider store={window.store}>
      <JoinNow />
    </Provider>,
  );

  const instagramElement = document.getElementById('instagram');
  const { token } = instagramElement.dataset;

  createRoot(
    instagramElement,
  ).render(
    <Instagram token={token} />,
  );

  const StickyCategories = React.lazy(() => import('../../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );

  AOS.init();
});
